import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more\"><path fill=\"#bfbfbf\" d=\"M509.497 792.917c51.769 0.114 93.525 41.87 93.411 93.753-0.113 51.655-42.097 93.64-93.866 93.526-51.542 0-93.526-42.212-93.412-93.98 0.114-51.656 41.984-93.299 93.867-93.299zM415.744 136.42c0-51.77 41.87-93.867 93.525-93.867 51.655-0.114 93.753 41.87 93.753 93.639 0 51.883-41.642 93.753-93.525 93.753s-93.753-41.643-93.753-93.525z m187.278 375.125c0 51.655-42.439 93.98-93.753 93.753-51.769-0.342-93.525-42.212-93.525-93.98 0-51.656 42.212-93.867 93.753-93.64 51.655 0.114 93.525 42.098 93.525 93.867z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/more.svg
// module id = gZ6Q
// module chunks = 54